import List from 'components/List'
import Panel from 'components/Panel'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc'
import FavoritesToggle from '../../containers/Favourites/Toggle'

const Container = styled.div`
  width: 100%;

  li {
    list-style-type: none;
  }
`

const Handle = styled.span`
  position: relative;
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  user-select: none;
  z-index: 2;
  display: block;
  float: left;
  padding-right: 5px;

  .fa-drag-handle:before {
    content: '\f142 \f142';
    letter-spacing: 2px;
    font-size: 14px;
    opacity: 0.5;
    padding-left: 10;
  }
`

const Favourites = ({ favourites, renderItemList, height, onSortEnd }) => {
  const icon = <FontAwesome name="star-o" />

  const DragHandle = SortableHandle(() => (
    <Handle>
      <FontAwesome name="drag-handle" />
    </Handle>
  ))

  const SortableFavourites = SortableElement(({ value }) => (
    <Container>
      <DragHandle />
      {renderItemList([value], { showType: true, showDevice: true })}
    </Container>
  ))

  const Favourites = SortableContainer(() => (
    <div>
      {favourites.map((item, index) => (
        <div style={{ display: 'flex' }} key={`item-${index}`}>
          <SortableFavourites
            key={`item-${index}`}
            index={index}
            value={item}
          />
          <FavoritesToggle {...item} />
        </div>
      ))}
    </div>
  ))

  return (
    <Panel title="Favorites" blue buttons={icon} height={height}>
      {favourites.length !== 0 && (
        <List>
          <Favourites distance={2} onSortEnd={onSortEnd} useDragHandle />
        </List>
      )}
      {favourites.length === 0 && (
        <div className="no-content">You don't have any favorites.</div>
      )}
    </Panel>
  )
}

export default Favourites
